function SectionHeading({ eyebrow, title, description, align = 'center', light = false }) {
  const alignClasses = align === 'left' ? 'text-left items-start' : 'text-center items-center'

  return (
    <div className={`flex flex-col ${alignClasses} mb-10`}>
      {eyebrow && (
        <span className={`text-xs font-bold uppercase tracking-widest mb-2 ${light ? 'text-accent-200' : 'text-accent-600'}`}>
          {eyebrow}
        </span>
      )}
      <h2 className={`text-2xl sm:text-3xl font-extrabold ${light ? 'text-white' : 'text-primary'}`}>
        {title}
      </h2>
      {description && (
        <p className={`mt-3 max-w-2xl text-sm sm:text-base ${light ? 'text-primary-100' : 'text-gray-600'}`}>
          {description}
        </p>
      )}
    </div>
  )
}

export default SectionHeading
